import { useState } from 'react';
import { message } from 'antd';
import queryString from 'query-string';
export interface EntNameParam {
    entName: string;
    page?: number;
    pageSize?: number;
}

const useFuzzySearchHooks = () => {
    const [data, setData] = useState<string[]>([]);
    const [value, setValue] = useState<string>('');

    const fetchData = async (url: string, params: EntNameParam) => {
        const sendparams = params;
        const res = await fetch(url, {
            credentials: 'same-origin',
            method: 'post',
            body: queryString.stringify({
                ...sendparams
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
            .then(res => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error('请求失败');
                }
            })
            .catch(res => {
                message.error(res);
            });
        if (res) {
            setData(res.result);
        }
    };

    return { data, value, setData, setValue, fetchData };
};

export default useFuzzySearchHooks;
